import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Testimonials extends Component {
  state = {
    testimonials: [],
    imagePreviewPath: "",
    formData: {
      id: null,
      testimonial_name: "",
      testimonial_designation: "",
      testimonial_message: "",
      testimonial_rating: "",
      testimonial_image: null,
      testimonial_status: "1",
      testimonial_date: "",
    },
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchTestimonials();

    const modalEl = document.getElementById("testimonialModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** ✅ Fetch all testimonials */
  fetchTestimonials = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/testimonials", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data?.data || [];
      this.setState({ testimonials: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          "Failed to load testimonials. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Reset form */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        testimonial_name: "",
        testimonial_designation: "",
        testimonial_message: "",
        testimonial_rating: "",
        testimonial_image: null,
        testimonial_status: "1",
        testimonial_date: "",
      },
      imagePreviewPath: "",
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** ✅ Input change */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        [name]: value,
      },
    }));
  };

  /** ✅ File change */
  handleFileChange = (e) => {
    const file = e.target.files[0];
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        testimonial_image: file || null,
      },
      imagePreviewPath: file ? URL.createObjectURL(file) : "",
    }));
  };

  /** ✅ Open modal */
  openModal = (mode = "add", testimonial = null) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("testimonialModal")
    );

    if (mode === "edit" && testimonial) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: testimonial.id,
          testimonial_name: testimonial.testimonial_name || "",
          testimonial_designation: testimonial.testimonial_designation || "",
          testimonial_message: testimonial.testimonial_message || "",
          testimonial_rating: testimonial.testimonial_rating || "",
          testimonial_image: null,
          testimonial_status:
            testimonial.testimonial_status?.toString() ?? "1",
          testimonial_date: testimonial.testimonial_date || "",
        },
        imagePreviewPath: testimonial.testimonial_image
          ? `${process.env.REACT_APP_API_URL}/uploads/testimonials/${testimonial.testimonial_image}`
          : "",
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** ✅ Submit add/update */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.testimonial_name) {
      return this.setState({ error: "Testimonial name is required." });
    }
    if (formData.testimonial_status === "") {
      return this.setState({ error: "Status is required." });
    }

    const data = new FormData();
    data.append("testimonial_name", formData.testimonial_name);
    data.append("testimonial_designation", formData.testimonial_designation);
    data.append("testimonial_message", formData.testimonial_message);
    data.append("testimonial_rating", formData.testimonial_rating);
    data.append("testimonial_status", formData.testimonial_status);
    data.append("testimonial_date", formData.testimonial_date);

    if (formData.testimonial_image) {
      data.append("testimonial_image", formData.testimonial_image);
    }

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/testimonials", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/testimonials/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchTestimonials();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("testimonialModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "Testimonial added successfully!"
            : "Testimonial updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving testimonial.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Confirm delete */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(
      document.getElementById("deleteModal")
    );
    modal.show();
  };

  /** ✅ Delete testimonial */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/testimonials/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await this.fetchTestimonials();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("deleteModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title: "Testimonial deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to delete testimonial.",
      });
    }
  };

  render() {
    const { testimonials, formData, imagePreviewPath, error, loading, submitting, modalMode, } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Testimonials</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>

                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Testimonial
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}

                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Rating</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {testimonials.length > 0 ? (
                            testimonials.map((testimonial, index) => (
                              <tr key={testimonial.id}>
                                <td>{index + 1}</td>
                                <td>
                                  {testimonial.testimonial_image ? (
                                    <img
                                      src={`${baseUrl}/uploads/testimonials/${testimonial.testimonial_image}`}
                                      alt={testimonial.testimonial_name}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  ) : (
                                    "N/A"
                                  )}
                                </td>
                                <td>{testimonial.testimonial_name}</td>
                                <td>
                                  {testimonial.testimonial_designation || "N/A"}
                                </td>
                                <td>
                                  {testimonial.testimonial_rating || "N/A"}
                                </td>
                                <td>
                                  {testimonial.testimonial_status === "1" ||
                                  testimonial.testimonial_status === 1 ? (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>{testimonial.testimonial_date || "N/A"}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() =>
                                      this.openModal("edit", testimonial)
                                    }
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>

                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() =>
                                      this.confirmDelete(testimonial.id)
                                    }
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No testimonials found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Modal */}
        <div className="modal fade" id="testimonialModal" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add"
                      ? "Add Testimonial"
                      : "Edit Testimonial"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    {/* Name */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        name="testimonial_name"
                        className="form-control"
                        value={formData.testimonial_name}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* Designation */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Designation</label>
                      <input
                        type="text"
                        name="testimonial_designation"
                        className="form-control"
                        value={formData.testimonial_designation}
                        onChange={this.handleChange}
                      />
                    </div>

                    {/* Rating */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Rating</label>
                      <input
                        type="text"
                        name="testimonial_rating"
                        className="form-control"
                        value={formData.testimonial_rating}
                        onChange={this.handleChange}
                        placeholder="e.g. 5"
                      />
                    </div>

                    {/* Date */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        name="testimonial_date"
                        className="form-control"
                        value={formData.testimonial_date}
                        onChange={this.handleChange}
                      />
                    </div>

                    {/* Status */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        name="testimonial_status"
                        className="form-select"
                        value={formData.testimonial_status}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    {/* Image */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Image</label>
                      <input
                        type="file"
                        name="testimonial_image"
                        className="form-control"
                        accept="image/*"
                        onChange={this.handleFileChange}
                      />
                    </div>

                    {imagePreviewPath && (
                      <div className="col-md-12 mb-3">
                        <img
                          src={imagePreviewPath}
                          alt="Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    )}

                    {/* Message */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Message</label>
                      <textarea
                        name="testimonial_message"
                        className="form-control"
                        rows="5"
                        value={formData.testimonial_message}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>

                    {error && (
                      <div className="col-md-12">
                        <div className="alert alert-danger">{error}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>

                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonials;

